import {store} from '../lib/store'
import {api} from '../lib/api'

export function getUrlParameter (sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}
export function getMonthName (n, flags) {
	flags = flags || ''

	let m = ''
	let t = true

	if (flags.indexOf('R') != -1) t = false

    if (n == 1) 	  m = t ? 'январь' : 'января'
    else if (n == 2)  m = t ? 'февраль' : 'февраля'
    else if (n == 3)  m = t ? 'март' : 'марта'
    else if (n == 4)  m = t ? 'апрель' : 'апреля'
    else if (n == 5)  m = t ? 'май' : 'мая'
    else if (n == 6)  m = t ? 'июнь' : 'июня'
    else if (n == 7)  m = t ? 'июль' : 'июля'
    else if (n == 8)  m = t ? 'август' : 'августа'
    else if (n == 9)  m = t ? 'сентябрь' : 'сентября'
    else if (n == 10) m = t ? 'октябрь' : 'октября'
    else if (n == 11) m = t ? 'ноябрь' : 'ноября'
    else if (n == 12) m = t ? 'декабрь' : 'декабря'

	if (flags.indexOf('UU') != -1) {
		m = m.toUpperCase()
	}
	if (flags.indexOf('Ul') != -1) {
		m = m[0].toUpperCase() + m.substring(1)
	}

	return m
}
export function numberFormat (number, decimals, dec_point, thousands_sep) {
	number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	var n = !isFinite(+number) ? 0 : +number,
	prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
	sep = (typeof thousands_sep === 'undefined') ? ' ' : thousands_sep,
	dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
	s = '',
	toFixedFix = function(n, prec) {
		var k = Math.pow(10, prec);
		return '' + (Math.round(n * k) / k)
		.toFixed(prec);
	};
	// Fix for IE parseFloat(0.55).toFixed(0) = 0;
	s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
	.split('.');
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || '')
	.length < prec) {
		s[1] = s[1] || '';
		s[1] += new Array(prec - s[1].length + 1)
		.join('0');
	}
	return s.join(dec);
}
export function toNum (string) {
	string = (string + '').replace(/\((.*)\)/g, '-$1')
	return +numberFormat(string, 4, '.', '')
}
export function toStr (number, decimals) {
	decimals = decimals === undefined ? 2 : decimals
	return numberFormat(number, decimals)
}
export function sumFormat (array, decimals) {
	let l = array.length
	let s = 0
	for (let i = 0; i < l; i++) {
		s += toNum(array[i])
	}
	return toStr(s, decimals)
}
export function randomString (len) {
	var result           = ''
	var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	var charactersLength = characters.length
	for (var i = 0; i < len; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength))
	}
	return result
}
export function escape(string) {
    return string.replace(/[&*+-\\<>`"']/g, "\\$&");
}
export function dateFormat (date) {
	if (!date) return null

	const [year, month, day] = date.split('-')
	return `${day}.${month}.${year}`
}
export function linkify (text) {
	var exp = /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
	return text.replace(exp, "<a href='$1' target='_blank'>$1</a>")
}
